import { render, staticRenderFns } from "./carsResults.vue?vue&type=template&id=75a1b268&scoped=true&"
import script from "./carsResults.vue?vue&type=script&lang=js&"
export * from "./carsResults.vue?vue&type=script&lang=js&"
import style0 from "./carsResults.vue?vue&type=style&index=0&id=75a1b268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a1b268",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VRow})
